export default __webpack_public_path__ + "static/media/mouth-diagram.816922b5.svg";